import axios from 'axios';

export function freshEducation() {
  return {
    school: '',
    degree: '',
    major: '',
    major_enum: '',
    gpa: '',
    gpa_out_of: '',
    start_date: '',
    end_date: '',
  };
}

export function normalizeEducationEntry({ school_name, university, school, ...rest }) {
  return {
    ...freshEducation(),
    ...rest,
    school: school_name ?? '',
  };
}

export function normalizeEducationEntries(entries) {
  return (entries ?? []).map(normalizeEducationEntry);
}

export async function fetchSchoolOptions() {
  const response = await axios.get('/api/education-options/universities/');
  return response.data.map(({ label }) => ({ value: label, label }));
}
